export const HUB_ENVS = ['dev', 'staging', 'prod', 'corp'] as const;
export type HubEnv = (typeof HUB_ENVS)[number];

export const HUB_ENV_HEADER = 'X-Hub-Env';

export const HUB_ENV_LABEL: Record<HubEnv, string> = {
  dev: 'Dev',
  staging: 'Staging',
  prod: 'Prod',
  corp: 'Corp',
};

export const HUB_ENV_FULL_LABEL: Record<HubEnv, string> = {
  dev: 'Development',
  staging: 'Staging',
  prod: 'Production',
  corp: 'Corporate',
};
